import React, {Fragment, useState, useContext, useEffect} from "react";
import { Grid, Paper, Typography, Button, Link } from "@material-ui/core";
import {
    FacebookIcon,
    FacebookMessengerIcon,
    WhatsappIcon,
    EmailIcon,
    EmailShareButton,
    FacebookShareButton,
    FacebookMessengerShareButton,
    WhatsappShareButton,
} from "react-share";

import CheckIcon from '@material-ui/icons/Check';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { ReactComponent as PlanningSvg } from '../assets/planning.svg';
import { ReactComponent as InvitePlaceholder } from '../assets/invitePlaceholder.svg';

import {InviteActions, InvitesContext} from "../context/InvitesContext";
import {ProviderRequestsActions, ProviderRequestsContext} from "../context/ProviderRequestsContext";
import LoginDetails from "./LoginDetails";
import {formatUrl} from "../utils/UrlUtils";
import {get, post} from "../utils/OctoberApiUtils";

export default function CreateInvite(props) {
    const { classes } = props;
    const invitesContext = useContext(InvitesContext);
    const providerRequestsContext = useContext(ProviderRequestsContext);
    const [userLoggedIn, setIsAuthenticated] = useState(false);
    const formatLink = (string) => formatUrl(string);

    // copy link to clipboard
    const linkToCopy = () => {
        const baseUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/invitatie/`;//.replace('https://', '').replace('http://', '');
        const inviteTitle = invitesContext.state.invite.eventTitle;
        const formattedTitle = formatLink(inviteTitle);
        const inviteLink = baseUrl.concat(`${invitesContext.state.invite.selectedInvite}/${invitesContext.state.invite.id}/`).concat(formattedTitle);
        return inviteLink;
    }
    const [copySuccess, setCopySuccess] = useState('');
    const hideCopySuccess = () => {
        setTimeout( () => {
            setCopySuccess('');
            }, 2000);
        return false;
    }
    const handleCopy = (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(linkToCopy());
        setCopySuccess('copied');
        hideCopySuccess();
    }

    // check user authentication
    useEffect(async () => {
        const result = await get('/api/react/auth/check');
        setIsAuthenticated(result.data);
    }, []);

    // check user authentication
    useEffect(async () => {
        const saveInvite = async () => {
            try {
                const response = await post('/api/react/add-event/invite', invitesContext.state.invite);
                invitesContext.dispatch({ type: InviteActions.INVITE_SAVED, id: response.data.id });
                providerRequestsContext.dispatch({ type: ProviderRequestsActions.CHANGE_INVITE_ID_VALUE, id: response.data.id });
                providerRequestsContext.dispatch({ type: ProviderRequestsActions.CHANGE_INVITE_URL_VALUE, value: linkToCopy().replace('undefined', response.data.id) });
                providerRequestsContext.dispatch({ type: ProviderRequestsActions.CHANGE_INVITE_TITLE_VALUE, value: invitesContext.state.invite.eventTitle });
            } catch (error) {
                console.error(`Cannot create invite, error`, error);
            }
        };
        if(userLoggedIn) {
            saveInvite();
            localStorage.setItem("clear", "true");
        }
    }, [userLoggedIn]);

    return (
        <Fragment>
            {userLoggedIn &&
                <Grid container spacing={2} noValidate className={classes.wrapFieldsAround + ' grayViewContainer'}>
                    <Grid container spacing={2} noValidate className={classes.inputContainer + ' grayView'}>
                        <Grid item sm={12} className={`${classes.noPadding} ${classes.inputContainer} ${classes.partyImage}`}>
                            <InvitePlaceholder className={`${classes.center}`} />
                        </Grid>
                        <Grid item sm={12} className={`${classes.noPadding} ${classes.linkContainer}`}>
                            <Paper square elevation={0} className={`${classes.inputFieldContainer} ${classes.copyContainer}`}>
                                <Typography>{linkToCopy()}</Typography>
                                { document.queryCommandSupported('copy') &&
                                    <Button className={classes.copyBtn} onClick={handleCopy} endIcon={copySuccess && <CheckIcon />}>Copy</Button>
                                }
                            </Paper>
                        </Grid>
                        <Grid item sm={12} className={`${classes.noPadding} ${classes.inputContainer}`}>
                            <Paper square elevation={0} className={classes.inputTitleContainer}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.fullWidthButton + ' firstBtn'}
                                >
                                    <Link href={linkToCopy()} color="secondary" target="_blank">
                                        Vizualizează invitația
                                    </Link>
                                </Button>
                            </Paper>
                        </Grid>
                        <Grid item sm={12} className={`${classes.noPadding} ${classes.readyToParty} grayBg`}>
                            <Paper square elevation={0} className={classes.inputContainer}>
                                <Typography className={`${classes.mb8} sectionTitle`}>Pregătit de petrecere?</Typography>
                                <Typography className={`${classes.mb8} subTitle`}>
                                    Planifică-ți evenimentul cu câteva clickuri în { ` ` }
                                    <Link href="https://belle-event.ro">
                                        my belle event
                                    </Link>
                                </Typography>
                                <PlanningSvg className={classes.center} />
                            </Paper>
                            <Button
                                variant="contained"
                                color="secondary"
                                className={classes.fullWidthButton + ' secondBtn'}
                            >
                                <Link href={process.env.REACT_APP_BACKEND_BASE_URL + '/planuri-my-belle-event'} color="primary">
                                    Începe
                                </Link>
                                {/* Începe */}
                            </Button>
                            <Link className="next-btn" href="https://belle-event.ro" color="primary" target="_blank">Află mai multe</Link>
                        </Grid>
                        <Grid item sm={12} className={classes.inviteDownloadContainer}>
                            <Paper square elevation={0} className={classes.inputTitleContainer}>
                                <Typography className={classes.inputTitleText + ' sectionTitle'}>Distribuie</Typography>
                            </Paper>
                            <Paper square elevation={0} className={`${classes.smIconsContainer} ${classes.wrapFields}`}>
                                <EmailShareButton subject={invitesContext.state.invite.eventTitle} url={linkToCopy()}>
                                    <EmailIcon size={32} round={true}  />
                                </EmailShareButton>
                                <span> </span>
                                <FacebookShareButton quote={invitesContext.state.invite.eventTitle} url={linkToCopy()}>
                                    <FacebookIcon size={32} round={true} />
                                </FacebookShareButton>
                                <span> </span>
                                <FacebookMessengerShareButton quote={invitesContext.state.invite.eventTitle} url={linkToCopy()}>
                                    <FacebookMessengerIcon size={32} round={true} />
                                </FacebookMessengerShareButton>
                                <span> </span>
                                <WhatsappShareButton title={invitesContext.state.invite.eventTitle} url={linkToCopy()}>
                                    <WhatsappIcon size={32} round={true} />
                                </WhatsappShareButton>
                            </Paper>
                        </Grid>
                        <Grid item sm={12} className={`${classes.noPadding} ${classes.inputContainer}`}>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.fullWidthButton + ' lastBtn'}
                            >
                                <Link href={process.env.REACT_APP_BACKEND_BASE_URL} color="secondary">
                                    Înapoi în site
                                </Link>
                                <ChevronRightIcon/>
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            }
            { !userLoggedIn &&
                <LoginDetails classes={classes}
                    setIsAuthenticated={setIsAuthenticated}/>
            }
        </Fragment>
    )
}